import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import Select from "react-select";
import { postRequest, request } from "../../../utils/request";
import { formatCurrency, getLink, money, toast } from "../../../utils/helpers";
import Modal from "../../general/Modal";
import SortableTable from "../../general/SortableTable";
import { auth } from "../../../utils/auth";
import Loader from "../../general/Loader";

const GenerarReporteDespachoForm = ({ facturas, tipo_despacho, onCancel, onSuccess, zonas, empleados, vehiculos, all, url }) => {
    const [todasZonas, local, ...zonasOptions] = zonas;
    const [todosEmpleados, ...todosLosEmpleados] = empleados;
    const [todosVehiculos, ...vehiculosOptions] = vehiculos;

    const empleadosOptions = todosLosEmpleados.filter((empleado) => empleado.active);

    const [loading, setLoading] = useState(false);
    const [loadingFacturas, setLoadingFacturas] = useState(all ? true : false);
    const [facturasData, setFacturasData] = useState(all ? [] : facturas);
    const [showModal, setShowModal] = useState(false);
    const [errors, setErrors] = useState({});
    const formRef = useRef(null);
    const user = auth.getUser();

    const getFacturas = async () => {
        setLoadingFacturas(true);

        if (all && url) {
            const response = await request(url + '&tipo_despacho=' + tipo_despacho.toLowerCase());
            setFacturasData(response.data);
        } else {
            setFacturasData(facturas);
        }

        setLoadingFacturas(false);
    };

    const regenerarReporte = async (e) => {
        e.preventDefault();

        if(loading) return;

        setLoading(true);

        const formData = new FormData(e.target);

        formData.append("tipo_despacho", tipo_despacho);
        if (tipo_despacho  !== "Carga" && user?.empleado?.id) {
            formData.append("empleado_id", user.empleado.id);
        }

        const res = await postRequest("despachos", formData);
        if(res.data.id) {
            // window.open(getLink(`/imprimir/ingresos/despacho-facturas/reporte?id=${res.data.id}`));
        
            onSuccess();
        } else {
            toast("Error al generar el reporte", "error");
        }

        setLoading(false);
    };

    const validateForm = () => {
        const errors = {};
        let validado = true;
        const formData = new FormData(formRef.current);

        if(!formData.get("fecha_entrega")) {
            errors.fecha_entrega = "Por favor, seleccione una fecha de entrega";
            validado = false;
        }

        if (tipo_despacho === "Carga" && !formData.get("zona_id")) {
            errors.zona_id = "Por favor, seleccione una zona de despacho";
            validado = false;
        }

        if (tipo_despacho === "Carga" && !formData.get("empleado_id")) {
            errors.empleado_id = "Por favor, seleccione un empleado de despacho";
            validado = false;
        }

        if (tipo_despacho === "Carga" && !formData.get("vehiculo_id")) {
            errors.vehiculo_id = "Por favor, seleccione un vehículo de despacho";
            validado = false;
        }

        setErrors(errors);
        return validado;
    }

    const openModal = () => {
        const valido = validateForm();
        if (valido) setShowModal(true);
    };

    const acceptModal = () => {
        setShowModal(false);

        formRef.current.requestSubmit();
    }

    useEffect(() => {
        getFacturas();
    }, [all, url]);

    return (<>
        <form ref={formRef} onSubmit={regenerarReporte}>
            <div className='popup__header'>Generar Reporte de Despacho de Facturas</div>
            
            <div className='popup__body'>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label>Fecha de entrega:</label>
                            <input
                                type='datetime-local'
                                name='fecha_entrega'
                                id='fecha_entrega'
                                className='form-control'
                                defaultValue={dayjs().format("YYYY-MM-DD HH:mm")}
                            />
                            {errors.fecha_entrega && (
                                <small className='help-blockParams form-Text'>
                                    {errors.fecha_entrega}
                                </small>
                            )}
                        </div>
                    </div>

                    {tipo_despacho === "Carga" && (<div className='col-md-6'>
                        <div className="form-group">
                            <label>Zona:</label>
                            <Select
                                name="zona_id"
                                isClearable
                                menuPosition="fixed"
                                options={tipo_despacho === "Entrega" ? [local] :zonasOptions}
                                defaultValue={tipo_despacho === "Entrega" ? local :  null}
                                isDisabled={tipo_despacho === "Entrega"}
                            />
                            {errors.zona_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.zona_id}
                                </small>
                            )}
                        </div>
                    </div>)}
                </div>

                {tipo_despacho === "Carga" && <div className='row'>
                    <div className='col-md-6'>
                        <div className="form-group">
                            <label>Entregado por:</label>
                            <Select
                                name="empleado_id"
                                isClearable
                                menuPosition="fixed"
                                options={empleadosOptions}
                            />
                            {errors.empleado_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.empleado_id}
                                </small>
                            )}
                        </div>
                    </div>

                    {tipo_despacho === "Carga" && (<div className='col-md-6'>
                        <div className="form-group">
                            <label>Vehículo:</label>
                            <Select
                                name="vehiculo_id"
                                isClearable
                                menuPosition="fixed"
                                options={vehiculosOptions}
                                isDisabled={tipo_despacho === "Entrega"}
                            />
                            {errors.vehiculo_id && (
                                <small className='help-blockParams form-Text'>
                                    {errors.vehiculo_id}
                                </small>
                            )}
                        </div>
                    </div>)}
                </div>}

                <hr />

                <div className="row mt-3">
                    <div className="col-12">
                        {loadingFacturas ? <Loader size="sm" /> :
                        <SortableTable rows={facturasData.map((factura) => ({
                            id: factura.id,
                            ncf: factura.numero_comprobante || factura.numero,
                            cliente: `${factura.cliente?.codigo} - ${factura.cliente?.nombre}`,
                            total: formatCurrency(factura.total),
                        }))} className="table" />}
                    </div>
                </div>
            </div>

            <div className='popup__footer'>
                <button type='button' className='btn btn-plain' onClick={onCancel} disabled={loading}>
                    Cancelar
                </button>
                <button type='button' className='btn btn-primary' disabled={loading || loadingFacturas} onClick={openModal}>
                    {loading ? "Generando..." : "Generar"}
                </button>
            </div>
        </form>

        <Modal
            show={showModal}
            blank={false}
            size={"600px"}
            toggle={() => {
                setShowModal(false);
            }}
            callback={acceptModal}
        >
            Se despacharán {facturasData.length} facturas. Esta acción no podrá revertirse. ¿Está seguro de querer despacharlas?
        </Modal>
    </>);
};

export default GenerarReporteDespachoForm;